import { createContext, useContext } from 'react';

/** Read-only mode for editing surfaces (see read-only.tsx). */
export const ReadOnlyContext = createContext(false);

export const useReadOnly = (): boolean => useContext(ReadOnlyContext);
